module.exports = __webpack_public_path__ + "static/media/1.34dd0f63.jpg";